import { EntityType } from '../../types/enums';
import { Action } from '../types/types';
import type { CommToggleState } from '../types/comm-toggle';

export type { CommToggleState } from '../types/comm-toggle';

export const defaultCommToggleState: CommToggleState = {
	version: 0,
	entityValue: [],
};

export const CommToggleReducer = (
	state: CommToggleState = defaultCommToggleState,
	action: Action,
) => {
	switch (action.type) {
		case EntityType.commsToggle:
			return action.payload;
		default:
			return state;
	}
};
